import { IDeviceManagerFilter, IDeviceMessageFilter } from '../../state/reducers/filterSortReducer';
import { SelectableOption } from '../FilterBar/select/selectable-option';

export const getGatewayFilterString = (filter?: IDeviceManagerFilter | IDeviceMessageFilter) => {
  return filter?.gateways?.map((gateway: SelectableOption) => gateway.value).join(',');
};
